export enum Entidade {
  CONTA = 'CONTA',
  PROCESSO = 'PROCESSO',
  PARCEIRO_NEGOCIO = 'PARCEIRO_NEGOCIO',
  USUARIO = 'USUARIO',
  TARIFARIO = 'TARIFARIO',
   TARIFARIO_TR = 'TARIFARIO_TR',
  TARIFARIO_LOCAL = 'TARIFARIO_LOCAL',
  OPORTUNIDADE = 'OPORTUNIDADE',
  OPORTUNIDADE_OFERTA = 'OPORTUNIDADE_OFERTA',
  FATURA = 'FATURA',
  DESPESA = 'DESPESA',
  PARAMETRO = 'PARAMETRO',
  OPORTUNIDADE_TR = 'OPORTUNIDADE_TR',
  OPORTUNIDADE_OFERTA_TR = 'OPORTUNIDADE_OFERTA_TR',
  PROCESSO_TR = 'PROCESSO_TR',
  FATURA_TR = 'FATURA_TR',
  VEICULO = 'VEICULO',
}
